<script setup>
import { useI18n } from 'vue-i18n';
import CampaignLayout from 'dashboard/components-next/Campaigns/CampaignLayout.vue';
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';

const { t } = useI18n();
</script>

<template>
  <CampaignLayout
    :header-title="t('CAMPAIGN.LIVE_CHAT.HEADER_TITLE')"
    :show-button="false"
  >
    <EmptyStateLayout
      :title="$t('CHANNEL_SELECTOR.COMING_SOON')"
      :subtitle="t('CAMPAIGN.LIVE_CHAT.HEADER_TITLE')"
      :show-backdrop="false"
    />
  </CampaignLayout>
</template>
